import { FaExternalLinkSquareAlt, FaGithubSquare, FaListAlt, FaRegListAlt } from 'react-icons/fa'
import { BsImageFill } from 'react-icons/bs'
import { MdClose } from 'react-icons/md'
import '../../css/IconBtn.css'

const IconBtnDefaults = {
  color: '#bc13fe',
  path: '',
  size: '2em',
  target: '#',
  title: '',
}

const iconMap = new Map([
  ['FaExternalLinkSquareAlt', FaExternalLinkSquareAlt],
  ['BsImageFill', BsImageFill],
  ['FaGithubSquare', FaGithubSquare],
  ['FaRegList', FaListAlt],
  ['FaRegListAlt', FaRegListAlt],
  ['MdClose', MdClose],
])

const IconBtn = ({ propOverrides = {}, clickhandler, work }) => {
  const Icon = iconMap.get(propOverrides?.path) || FaListAlt
  const iconBtnProps = { ...IconBtnDefaults, ...propOverrides }

  const handleClick = e => {
    if (propOverrides?.disabled) {
      e.preventDefault()
      return
    }
    if (propOverrides?.isaction) {
      e.preventDefault()
      clickhandler && clickhandler(e, work)
    }
  }
  return (
    <a href={iconBtnProps.target} onClick={handleClick} target='_blank' rel='noreferrer' className={`icon iconBtn  ${propOverrides.disabled && ' disabled'}`}>
      <Icon {...{ ...iconBtnProps }} />
    </a>
  )
}

export default IconBtn
